import Text from '~/components/Text';
import { useInvoiceListContext } from '../hooks/useInvoiceListContext';
import * as Styles from './styles';
import { fmPrice } from '~/utils/amount';
import Gap from '~/components/Gap';
import InvoiceStatusPills from '../CellContent/InvoiceStatusPills';
import { formatDate } from '~/utils/datetime';
import InvoiceContextMenu from '../CellContent/InvoiceContextMenu';
import InvoiceDueStatus from '../InvoiceDueStatus';

const InvoiceList = () => {
  const { listIds, maxListItems, listData, onOpenViewInvoiceModal } = useInvoiceListContext();
  return (
    <div>
      <ul>
        {listIds.slice(0, maxListItems ?? listIds.length).map(invoiceId => {
          const thisInvoiceData = listData[invoiceId];
          const formattedDate = thisInvoiceData.invoice_date
            ? formatDate(thisInvoiceData.invoice_date)
            : null;

          return (
            <Styles.ListItem key={invoiceId}>
              <Styles.LeftContainer
                onClick={() => {
                  onOpenViewInvoiceModal(thisInvoiceData.invoice_uuid);
                }}
              >
                <Text size="xsmd" className="bold">{thisInvoiceData.invoice_number}</Text>
                <Gap t={3} />
                <Text size="xsmd" variant="secondary">
                  {thisInvoiceData.buyer_company_name}
                </Text>
                <Gap t={3} />
                <Text size="xxsmd" variant="neutral">
                  {formattedDate}
                </Text>
              </Styles.LeftContainer>

              <Styles.RightContainer>
                <div className="d-flex">
                  <div>
                    <Text className="bold" align="right">
                      {fmPrice(thisInvoiceData.currency, thisInvoiceData.total_amount)}
                    </Text>
                    <Gap t={4} />
                    <div className="full-width end-align-center">
                      <InvoiceStatusPills invoiceData={thisInvoiceData} />
                    </div>
                    <Gap t={4} />
                    <div className="end-align-center">
                      <InvoiceDueStatus invoiceData={thisInvoiceData} />
                    </div>
                  </div>
                  <Gap l={8} />
                  <InvoiceContextMenu invoiceReferenceId={invoiceId} />
                </div>
              </Styles.RightContainer>
            </Styles.ListItem>
          );
        })}
      </ul>
    </div>
  );
};

export default InvoiceList;
